import { ISurvey } from 'app/interfaces/ISurvey'

export class SurveyStructureElementValidationError extends Error {
  constructor() {
    super()
    this.name = 'Invalid structure elements'
  }

  missingQuestionFromQuestionsIndex(questionKey, availableQuestionKeys: string[]) {
    this.message = `The question key <${questionKey}> referenced in questionsIndex was not found within the available question keys <${availableQuestionKeys.join(', ')}>. Either remove the question key from the structure elements, or add the question with key <${questionKey}> to the question list.`
    return this
  }

  duplicatedInfoTypeQuestions(survey: ISurvey, duplicatedInfoTypeQuestion: string) {
    this.name = `Duplicated ${duplicatedInfoTypeQuestion} question type`
    this.message = `The survey (id: ${survey.id}) contains an Info question type duplication for the type <${duplicatedInfoTypeQuestion}>. Only one question of this type can be present in a survey at a time. `
    return this
  }

  conflictingInfoContactModes(survey: ISurvey) {
    this.name = 'Conflicting info contact modes'
    this.message =
      `The survey (id: ${survey.id}) cannot combine an "infos" question group with standalone contact info questions ` +
      `(infoName, infoAddress, infoEmail, infoPhone) in other groups. Use one mode or the other.`
    return this
  }
}
